export const MIX = 'MIX';
export const ALTERNATE = 'ALTERNATE';
export const ROUND_ROBIN = 'ROUND_ROBIN';
